import React, { Component } from 'react';
import Menu from '@tencent/dui/lib/components/Menu';
import i18n from '@i18next/i18n';
import ColorPickerIcon from '@framework/frame-pc/components/palette-panel/images/color-picker.svg';
import ColorPicker from '@framework/frame-pc/components/color-picker';
import { IMenuManager } from '@src/slide/application/service/menu-manager/menu-manager.interface';

type IColorPickerItemProps = {
    onColorChange: any;
    menuManager?: IMenuManager;
};

export default class ColorPickerItem extends Component<IColorPickerItemProps> {
    public render() {
        return (
            <div>
                <Menu.Item id="color-picker-item" style={{ justifyContent: 'flex-start', margin: '0px -8px' }} onClick={this.handleClick}>
                    <img src={ColorPickerIcon} alt={''} style={{ marginLeft: -20 }}></img>
                    <span style={{ marginLeft: 10 }}>{i18n.t('取色器')}</span>
                </Menu.Item>
            </div>
        );
    }

    private handleClick = (e) => {
        const dom = document.getElementById('PopupWrapper');
        ColorPicker.show(dom, {
            handleColorChange: this.props.onColorChange,
            point: {
                clientX: e.clientX,
                clientY: e.clientY,
            },
            onVisibleChange: (visible) => {
                if (this.props.menuManager) {
                    this.props.menuManager.isColorPicking = visible;
                }
            },
        });
    };
}
